import {Model} from 'vue-mc';
//import { boolean , equal , integer , min , required , string , and , length , alphanumeric } from 'vue-mc/validation';

export class PlantillaCorreoModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      clave : ""
      , descripcion : ""
      , remitente : ""
      , multiListPerfilesDestinatarios : []
      , destinatariosOpcionales : ""
      , cc : ""
      , cco : ""
      , asunto : ""
      , cuerpo : ""
      , status : true
      , version: 0
    }
  }

  // Attribute mutations.
  mutations() {
    return {
        clave:clave=>clave      
      , descripcion:descripcion=>descripcion
      , remitente:remitente=>remitente
      , multiListPerfilesDestinatarios:multiListPerfilesDestinatarios=>multiListPerfilesDestinatarios     
      , destinatariosOpcionales:destinatariosOpcionales=>destinatariosOpcionales      
      , cc:cc=>cc  
      , cco:cco=>cco       
      , asunto:asunto=>asunto   
      , cuerpo:cuerpo=>cuerpo   
      , status:status=>status     
      , version:version=>version     
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}


// WEBPACK FOOTER //
// ./src/models/generales/plantilla-correo.js